'use strict';
const performanceMeasure = require('./performanceMeasure.js');

module.exports = {
    /**
     * Wait for a Web Component to be defined and return its class.
     *
     * @param {string} dependencyName - custom element tag name.
     * @returns {Promise} - Promise of class corresponding to the custom element.
     *
     * Note: `whenDefined` does not just wait for the Javascript file to be downloaded
     * and executed, it also waits for the upgrade of the corresponding elements.
     */
    getDependencyClass: (dependencyName) => {
        if (!dependencyName) {
            throw new Error('dependencyName required');
        }
        let measure = performanceMeasure('dependency:' + dependencyName);
        return window.customElements.whenDefined(dependencyName).then(() => {
            measure.end();
            return window.customElements.get(dependencyName);
        });
    },

    /**
     * Wait for the Web Component to be defined and return the first corresponding element.
     *
     * @param {string} dependencyName - custom element tag name.
     * @param {HTMLElement} baseElement - element to run querySelector on, defaults to document.
     * @returns {Promise} - Promise of the first HTMLElement corresponding to the query.
     */
    getFirstDependencyElement: (dependencyName, baseElement) => {
        if (!dependencyName) {
            throw new Error('dependencyName required');
        }
        if (!baseElement) {
            baseElement = document;
        }
        return window.customElements.whenDefined(dependencyName).then(() => {
            const element = baseElement.querySelector(dependencyName);
            if (!element) {
                throw new Error(dependencyName + ' element cannot be found');
            }
            return element;
        });
    },

    phoenixCustomElement: (tagName, Class) => {
        if (!window.customElements.get(tagName)) {
            window.customElements.define(tagName, Class);
        }
    },
};
